import * as React from 'react';
import type { SVGProps } from 'react';
const SvgProcessingSpinner = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 46.9514 52" {...props}>
    <path
      d="M20.9514 4C24.6571 4 28.3027 4.93604 31.55 6.72126C34.7973 8.50647 37.541 11.083 39.5266 14.2118C41.5122 17.3406 42.6753 20.9203 42.908 24.6186C43.1407 28.317 42.4354 32.0142 40.8576 35.3672C39.2798 38.7201 36.8806 41.6203 33.8827 43.7984C30.8847 45.9765 27.3852 47.3621 23.7087 47.8265C20.0323 48.291 16.2981 47.8192 12.8527 46.4551C9.40722 45.0909 6.36218 42.8786 4.00011 40.0233"
      stroke="currentColor"
      strokeWidth={8}
      strokeLinecap="round"
    />
  </svg>
);
export default SvgProcessingSpinner;
